import React from 'react';
import { Button } from 'primereact/button';
import { useTheme } from '@app/contexts/ThemeContext';
import { ThemeEnum } from '@app/models/ThemeEnum';
import styles from './ThemeToggle.module.scss';

export const ThemeToggle: React.FC = () => {
    const { theme, toggleTheme } = useTheme();

    return (
        <Button
            icon={theme === ThemeEnum.LIGHT ? 'pi pi-moon' : 'pi pi-sun'}
            className={`p-button-rounded p-button-text ${styles.themeToggle}`}
            onClick={toggleTheme}
            tooltip={theme === ThemeEnum.LIGHT ? 'Switch to dark mode' : 'Switch to light mode'}
            tooltipOptions={{ position: 'left' }}
            aria-label={theme === ThemeEnum.LIGHT ? 'Switch to dark mode' : 'Switch to light mode'}
        />
    );
};